import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";
import { Link } from "../link";

const BannerMenu = ({ bannerMenu, origin, showVerticalBanner, className }) => {
  return bannerMenu ? (
    <>
      <div
        className={classNames(
          "row banner-menu__wrapper",
          (origin === "new-menu" || origin === "accessories") && "banner-menu__wrapper--new-menu",
          origin === "support" && "banner-menu__wrapper--support",
          className
        )}
      >
        {bannerMenu?.image && bannerMenu?.ctaLabel !== "" ? (
          <div
            className={classNames(
              "col-12",
              (origin === "new-menu" || origin === "accessories") && "col-lg-5 col-xl-6",
              origin !== "new-menu" && origin !== "accessories" && "col-lg-5 col-xl-6",
              showVerticalBanner && "d-lg-none hide-vertical"
            )}
          >
            <GatsbyImage
              image={getImage(bannerMenu?.image?.node)}
              alt={bannerMenu?.image?.value?.description || ""}
            />
          </div>
        ) : bannerMenu?.image && bannerMenu?.ctaLabel === "" ? (
          <div
            className={classNames(
              "col-12",
              (origin === "new-menu" || origin === "accessories") && "col-lg-5 col-xl-6",
              origin !== "new-menu" && origin !== "accessories" && "col-lg-5 col-xl-6",
              showVerticalBanner && "d-lg-none hide-vertical"
            )}
          >
            <Link target={bannerMenu?.ctaTarget?.[0] || "_blank"} to={bannerMenu?.ctaLink}>
              <GatsbyImage
                image={getImage(bannerMenu?.image?.node)}
                alt={bannerMenu?.image?.value?.description || ""}
              />
            </Link>
          </div>
        ) : null}
        <div
          className={classNames(
            "col-12 col-lg-7 col-xl-6 banner-menu__text",
            showVerticalBanner && "col-lg-12 col-xl-12",
            (origin === "new-menu" || origin === "accessories") && "col-lg-7"
          )}
        >
          {bannerMenu?.title && bannerMenu?.ctaLabel !== "" ? (
            <div
              className={classNames(
                "banner-menu__title",
                origin === "new-menu" && "banner-menu__title--new-menu",
                origin === "accessories" && "banner-menu__title--accessories",
                showVerticalBanner && "banner-menu__title--vertical"
              )}
            >
              {bannerMenu.title}
            </div>
          ) : bannerMenu?.title && bannerMenu?.ctaLabel === "" ? (
            <Link
              className={classNames(
                "banner-menu__title",
                (origin === "new-menu" || origin === "accessories") &&
                  "banner-menu__title--new-menu",
                showVerticalBanner && "banner-menu__title--vertical"
              )}
              target={bannerMenu?.ctaTarget?.[0] || "_blank"}
              to={bannerMenu?.ctaLink}
            >
              {bannerMenu.title}
            </Link>
          ) : null}
          {bannerMenu?.newTitle && bannerMenu?.ctaLabel !== "" ? (
            <div
              className={classNames(
                "banner-menu__title",
                origin === "new-menu" && "banner-menu__title--new-menu",
                origin === "accessories" && "banner-menu__title--accessories",
                origin === "support" && "banner-menu__title--support",
                showVerticalBanner && "banner-menu__title--vertical"
              )}
            >
              {bannerMenu.newTitle}
            </div>
          ) : bannerMenu?.newTitle && bannerMenu?.ctaLabel === "" ? (
            <Link
              className={classNames(
                "banner-menu__title",
                origin === "new-menu" && "banner-menu__title--new-menu",
                origin === "accessories" && "banner-menu__title--accessories",
                origin === "support" && "banner-menu__title--support",
                showVerticalBanner && "banner-menu__title--vertical"
              )}
              target={bannerMenu?.ctaTarget?.[0] || "_blank"}
              to={bannerMenu?.ctaLink}
            >
              {bannerMenu.newTitle}
            </Link>
          ) : null}
          {bannerMenu?.image && bannerMenu?.ctaLabel !== "" ? (
            <div
              className={classNames(
                "col-12 mt-lg-3 mb-lg-3 d-none",
                showVerticalBanner && "d-lg-block hide-vertical",
                (origin === "new-menu" || origin === "accessories") && "col-lg-4",
                origin !== "new-menu" && origin !== "accessories" && "col-lg-6"
              )}
            >
              <GatsbyImage
                image={getImage(bannerMenu?.image?.node)}
                alt={bannerMenu?.image?.value?.description || ""}
              />
            </div>
          ) : bannerMenu?.image && bannerMenu?.ctaLabel === "" ? (
            <div
              className={classNames(
                "col-12 mt-lg-3 mb-lg-3 d-none",
                showVerticalBanner && "d-lg-block hide-vertical",
                (origin === "new-menu" || origin === "accessories") && "col-lg-4",
                origin !== "new-menu" && origin !== "accessories" && "col-lg-6"
              )}
            >
              <Link target={bannerMenu?.ctaTarget?.[0] || "_blank"} to={bannerMenu?.ctaLink}>
                <GatsbyImage
                  image={getImage(bannerMenu?.image?.node)}
                  alt={bannerMenu?.image?.value?.description || ""}
                />
              </Link>
            </div>
          ) : null}
          {bannerMenu?.abstract && (
            <div
              className={classNames(
                "banner-menu__abstract",
                origin === "new-menu" && "banner-menu__abstract--new-menu",
                origin === "accessories" && "banner-menu__abstract--accessories",
                origin === "support" && "banner-menu__abstract--support",
                showVerticalBanner && "banner-menu__abstract--vertical"
              )}
              dangerouslySetInnerHTML={{ __html: bannerMenu.abstract }}
            ></div>
          )}
          {bannerMenu?.ctaLabel && (
            <Link
              className={classNames(
                "",
                bannerMenu?.ctaType?.[0] !== "underline" &&
                  origin !== "support" &&
                  origin !== "new-menu" &&
                  "btn-link banner-menu__link",
                bannerMenu?.ctaType?.[0] !== "underline" &&
                  (origin === "support" || origin === "new-menu") &&
                  "banner-menu__link--support",
                bannerMenu?.ctaType?.[0] === "underline" && "banner-menu__link--underline",
                bannerMenu?.ctaType?.[0] === "underline" &&
                  (origin === "support" || origin === "new-menu") &&
                  "banner-menu__link--underline-support",
                showVerticalBanner && "banner-menu__link--vertical"
              )}
              target={bannerMenu?.ctaTarget?.[0] || "_blank"}
              to={bannerMenu?.ctaLink}
            >
              {bannerMenu.ctaLabel}
            </Link>
          )}
        </div>
      </div>
    </>
  ) : null;
};

export default BannerMenu;
